import api from "@/api";
export default class PurchaseOrder {
  constructor(rawdata = {}) {
    this.id = rawdata.id ? rawdata.id : 0;
    this.supplier = rawdata.supplier ? rawdata.supplier : null;
    this.supplier_id = rawdata.supplier ? rawdata.supplier.id : "";
    this.status = rawdata.status ? rawdata.status : "";
    this.requests = rawdata.requests ? rawdata.requests : [];
    this.requested_by = rawdata.requested_by ? rawdata.requested_by : null;
    this.po_date = rawdata.po_date ? rawdata.po_date : new Date().toISOString().slice(0, 10);
    this.po_no = rawdata.po_no ? rawdata.po_no : "";
    this.item_status = rawdata.item_status ? rawdata.item_status : "";
    this.item_id = rawdata.item_id ? rawdata.item_id : "";
    this.req_id = rawdata.req_id ? rawdata.req_id : "";
    this.quote_no = rawdata.quote_no ? rawdata.quote_no : "";
    this.status_id = rawdata.status_id ? rawdata.status_id : "";
  }

  static async getList(params) {
    const result = await api.get(`/api/v1/purchase/po_list/`, params);
    if (result && result.status == 200) return result.data;
    return null;
  }

  static async create(payload) {
    var result = await api.post(
      `/api/v1/purchase/request_po/`,
      payload,
      "json"
    );
    if (result && result.status == 200) return result.data.data;

    return null;
  }

  static async update(payload) {
    var result = await api.put(
      `/api/v1/purchase/po_update/${payload.id}/`,
      payload
    );
    if (result && result.status == 200) return result.data.data;

    return null;
  }

  static async fetch(id) {
    var result = await api.get(`/api/v1/purchase/items/?po_id=${id}`);
    if (result && result.status == 200) return result.data.data[0];

    return null;
  }

  static async item_complete(id) {
    var result = await api.put(`/api/v1/purchase/complete_item/${id}/`);
    if (result && result.status == 200) return result.data;

    return null;
  }

  static async po_complete(id) {
    var result = await api.put(`/api/v1/purchase/complete_po/${id}/`);
    if (result && result.status == 200) return result.data;

    return null;
  }

  static async getOpenPO() {
    const result = await api.get(`api/v1/purchase/get_inc_po/`);
    if (result && result.status == 200) {
      return result.data.data;
    }
    return null;
  }

  static rules() {
    return {
      supplier_id: [
        {
          required: true,
          message: "Supplier information is required.",
          trigger: "change"
        }
      ],
      po_no: [
        {
          required: true,
          message: "PO Number is required.",
          trigger: "blur"
        }
      ],
      quote_no: [
        {
          required: true,
          message: "Quote Number is required.",
          trigger: "blur"
        }
      ]
    };
  }
}
